import { Grid, Card, Typography, Box, Pagination, CardContent } from '@mui/material';
import dayjs from 'dayjs';
import { t } from 'i18next';

export default function PendingQuestionnaires({
    pendingAnswers,
    pendingTotalCount,
    pendingPaginationModel,
    setPendingPaginationModel
}) {
    return (
        <Card sx={{ mb: 3 }}>
            <CardContent sx={{ backgroundColor: '#f9f9f9' }}>
                <Typography variant="h5" fontWeight={700}>
                    {t('questionnaires.pending')}
                </Typography>
                <Box
                    sx={{
                        height: 3,
                        width: 180,
                        backgroundColor: '#1976d2',
                        borderRadius: 2,
                        mb: 2
                    }}
                />

                {Array.isArray(pendingAnswers) && pendingAnswers.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                        {t('questionnaires.noPending')}
                    </Typography>
                ) : (
                    <Grid container spacing={2}>
                        {pendingAnswers.map((qa) => (
                            <Grid item xs={12} sm={6} md={4} key={qa.uuid}>
                                <Card variant="outlined" sx={{ p: 2 }}>
                                    <Typography variant="h6" gutterBottom>
                                        {qa.questionnaire.name}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {t('questionnaires.availableSince')} {dayjs(qa.not_before).format('DD/MM/YYYY')}
                                    </Typography>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                )}

                {pendingTotalCount > pendingPaginationModel.pageSize && (
                    <Box display="flex" justifyContent="center" mt={2}>
                        <Pagination
                            count={Math.ceil(
                                pendingTotalCount / pendingPaginationModel.pageSize
                            )}
                            page={pendingPaginationModel.page + 1}
                            onChange={(_, newPage) =>
                                setPendingPaginationModel((prev) => ({
                                    ...prev,
                                    page: newPage - 1
                                }))
                            }
                            color="primary"
                        />
                    </Box>
                )}
            </CardContent>
        </Card>
    );
}
